let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1YAoN")).then(() => parcelRequire('jNc8I'));